import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Button from '@Components/Button';


function SelectedSearchItemTag(props) {
  const {
    item,
    onClickThesaurusItem,
  } = props;
  const title = item.get('title');

  return (
    <div
      title={title}
      className='tree-view-dialog-selected-search-items-tag'
    >
      {title}
      <Button
        buttonConfig={{
          type: 'link',
          size: 'xs',
          className: 'tree-view-dialog-selected-search-items-remove-button',
          e2eName: 'remove',
          ariaLabel: 'Remove',
        }}
        iconConfig={{ name: 'delete', size: 'tiny' }}
        onClick={() => {
          onClickThesaurusItem(item);
        }}
      />
    </div>
  );
}

SelectedSearchItemTag.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  onClickThesaurusItem: PropTypes.func.isRequired,
};


export default SelectedSearchItemTag;
